// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.brewcontrol_run_sync_status_enum */
var BrewcontrolRunSyncStatusEnum;
(function (BrewcontrolRunSyncStatusEnum) {
    BrewcontrolRunSyncStatusEnum["backfilling"] = "backfilling";
    BrewcontrolRunSyncStatusEnum["live"] = "live";
})(BrewcontrolRunSyncStatusEnum || (BrewcontrolRunSyncStatusEnum = {}));
;
export default BrewcontrolRunSyncStatusEnum;
/** Zod schema for brewcontrol_run_sync_status_enum */
export const brewcontrolRunSyncStatusEnum = z.nativeEnum(BrewcontrolRunSyncStatusEnum);
//# sourceMappingURL=BrewcontrolRunSyncStatusEnum.js.map